import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import {  NgModule } from '@angular/core';
import { LoginComponent } from './login/login.component';
import { SharedModule } from '../shared';
import { MaterialModule } from '../material.module';
import { LoginRoutingModule } from '../login/login-routing.module';
import { NoAuthGuardService } from './no-auth-guard.service';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { MFACodeComponent } from './mfa-code/mfa-code.component';
import { ForgotUsernameComponent } from './forgot-username/forgot-username.component';

@NgModule({
  declarations: [LoginComponent, ForgotPasswordComponent, MFACodeComponent, ForgotUsernameComponent],
  imports: [
    FormsModule,
    ReactiveFormsModule,
    CommonModule,
    SharedModule,
    MaterialModule,
    LoginRoutingModule
  ],
  providers: [
    NoAuthGuardService
  ]
})
export class LoginModule { }
